<app-nav></app-nav>

<div class="container-fluid">
    <div class="row">
        <div class="col-md-2 bg-white min-vh-100 border-right d-print-none">
            <app-sidebar></app-sidebar>
        </div>
        <!-- Main -->
        <main class="col-md-10 ml-sm-auto px-4 py-4 bg-light min-vh-100">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="h4 text-secondary d-print-none"><i class="fas fa-tachometer-alt mr-2"></i> Dashboard</h2>
            </div>

            <!-- Card contenedor -->
            <div class="card border-0 shadow rounded">
                <div class="card-body">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </main>

    </div>
</div>